import { SvgIcon, SvgIconProps } from "@mui/material";

export const CategoryIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#008B07"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ExpiryDateIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "24", height: "24", fill: "none" }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1 4C1 3.44772 1.44772 3 2 3H16C16.5523 3 17 3.44771 17 4V16C17 16.5523 16.5523 17 16 17H2C1.44772 17 1 16.5523 1 16V4Z"
        stroke="#008B07"
        strokeWidth="2"
      />
      <path d="M1 8H17" stroke="#008B07" strokeWidth="2" />
      <path d="M14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1H14ZM14 3V1H12V3H14Z" fill="#008B07" />
      <path d="M6 1C6 0.447715 5.55228 0 5 0C4.44772 0 4 0.447715 4 1H6ZM6 3V1H4V3H6Z" fill="#008B07" />
    </SvgIcon>
  );
};

export const BackButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M16.6668 10H3.3335M3.3335 10L8.3335 15M3.3335 10L8.3335 5"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BackButtonWhiteIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.1667 10H3.83333M3.83333 10L8.83333 15M3.83333 10L8.83333 5"
        stroke="white"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AppStoreButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "135", height: "40", fill: "none" }}
      width="135"
      height="40"
      viewBox="0 0 135 40"
      fill="none"
    >
      <rect x="0.5" y="0.5" width="134" height="39" rx="6.5" fill="white" />
      <rect x="0.5" y="0.5" width="134" height="39" rx="6.5" stroke="black" />
      <path
        d="M81.5257 19.2013V21.4924H80.0896V22.9948H81.5257V28.0998C81.5257 29.8429 82.3143 30.5402 84.2981 30.5402C84.6468 30.5402 84.9788 30.4987 85.2693 30.4489V28.9631C85.0203 28.988 84.8626 29.0046 84.5887 29.0046C83.7005 29.0046 83.3104 28.5895 83.3104 27.6432V22.9948H85.2693V21.4924H83.3104V19.2013H81.5257Z"
        fill="black"
      />
      <path
        d="M90.3232 30.6647C92.9628 30.6647 94.5815 28.8967 94.5815 25.9665C94.5815 23.0529 92.9545 21.2765 90.3232 21.2765C87.6835 21.2765 86.0566 23.0529 86.0566 25.9665C86.0566 28.8967 87.6752 30.6647 90.3232 30.6647ZM90.3232 29.0793C88.7709 29.0793 87.8994 27.9421 87.8994 25.9665C87.8994 24.0075 88.7709 22.862 90.3232 22.862C91.8671 22.862 92.747 24.0075 92.747 25.9665C92.747 27.9338 91.8671 29.0793 90.3232 29.0793Z"
        fill="black"
      />
      <path
        d="M95.9664 30.4904H97.7511V25.153C97.7511 23.883 98.7056 23.028 100.059 23.028C100.374 23.028 100.905 23.0861 101.055 23.1359V21.3762C100.864 21.3263 100.524 21.3014 100.258 21.3014C99.0792 21.3014 98.0748 21.9489 97.8175 22.8371H97.6846V21.4509H95.9664V30.4904Z"
        fill="black"
      />
      <path
        d="M105.486 22.7956C106.806 22.7956 107.669 23.717 107.711 25.1364H103.145C103.245 23.7253 104.166 22.7956 105.486 22.7956ZM107.702 28.05C107.37 28.7555 106.632 29.1457 105.552 29.1457C104.125 29.1457 103.203 28.1413 103.145 26.5558V26.4562H109.529V25.8337C109.529 22.9948 108.009 21.2765 105.494 21.2765C102.946 21.2765 101.327 23.111 101.327 25.9997C101.327 28.8884 102.913 30.6647 105.503 30.6647C107.57 30.6647 109.014 29.6686 109.421 28.05H107.702Z"
        fill="black"
      />
      <path
        d="M69.8221 27.1522C69.9598 29.372 71.8095 30.7915 74.5626 30.7915C77.505 30.7915 79.3462 29.3031 79.3462 26.9286C79.3462 25.0616 78.2966 24.0292 75.7499 23.4355L74.382 23.1C72.7645 22.7214 72.1106 22.2138 72.1106 21.3277C72.1106 20.2092 73.1259 19.4779 74.6487 19.4779C76.0941 19.4779 77.0921 20.192 77.2727 21.3363H79.1483C79.0365 19.2456 77.1953 17.7744 74.6745 17.7744C71.9644 17.7744 70.1576 19.2456 70.1576 21.4567C70.1576 23.2807 71.1815 24.3647 73.427 24.8895L75.0272 25.2767C76.6705 25.6638 77.3932 26.2317 77.3932 27.1781C77.3932 28.2793 76.2575 29.0794 74.7089 29.0794C73.0484 29.0794 71.8955 28.3309 71.7321 27.1522H69.8221Z"
        fill="black"
      />
      <path
        d="M51.3348 21.3014C50.1063 21.3014 49.0437 21.9157 48.4959 22.945H48.3631V21.4509H46.6448V33.4953H48.4295V29.1208H48.5706C49.0437 30.0754 50.0647 30.6398 51.3514 30.6398C53.6341 30.6398 55.0867 28.8386 55.0867 25.9665C55.0867 23.0944 53.6341 21.3014 51.3348 21.3014ZM50.8284 29.0378C49.3343 29.0378 48.3963 27.8591 48.3963 25.9748C48.3963 24.0822 49.3343 22.9035 50.8367 22.9035C52.3475 22.9035 53.2522 24.0573 53.2522 25.9665C53.2522 27.884 52.3475 29.0378 50.8284 29.0378Z"
        fill="black"
      />
      <path
        d="M61.3316 21.3014C60.103 21.3014 59.0405 21.9157 58.4927 22.945H58.3599V21.4509H56.6416V33.4953H58.4263V29.1208H58.5674C59.0405 30.0754 60.0615 30.6398 61.3482 30.6398C63.6309 30.6398 65.0835 28.8386 65.0835 25.9665C65.0835 23.0944 63.6309 21.3014 61.3316 21.3014ZM60.8252 29.0378C59.3311 29.0378 58.3931 27.8591 58.3931 25.9748C58.3931 24.0822 59.3311 22.9035 60.8335 22.9035C62.3443 22.9035 63.249 24.0573 63.249 25.9665C63.249 27.884 62.3443 29.0378 60.8252 29.0378Z"
        fill="black"
      />
      <path
        d="M43.4428 30.4904H45.4905L41.008 18.0755H38.9346L34.4521 30.4904H36.431L37.5752 27.1953H42.3072L43.4428 30.4904ZM39.8724 20.3297H40.0186L41.8168 25.5778H38.0656L39.8724 20.3297Z"
        fill="black"
      />
      <path
        d="M35.6514 8.71069V14.6997H37.8137C39.5984 14.6997 40.6318 13.5999 40.6318 11.6865C40.6318 9.80225 39.5901 8.71069 37.8137 8.71069H35.6514ZM36.5811 9.55737H37.71C38.9509 9.55737 39.6855 10.3459 39.6855 11.699C39.6855 13.0728 38.9634 13.853 37.71 13.853H36.5811V9.55737Z"
        fill="black"
      />
      <path
        d="M43.7969 14.7869C45.1167 14.7869 45.9261 13.9028 45.9261 12.4377C45.9261 10.981 45.1126 10.0928 43.7969 10.0928C42.4771 10.0928 41.6636 10.981 41.6636 12.4377C41.6636 13.9028 42.4729 14.7869 43.7969 14.7869ZM43.7969 13.9941C43.0208 13.9941 42.585 13.4255 42.585 12.4377C42.585 11.4583 43.0208 10.8855 43.7969 10.8855C44.5689 10.8855 45.0088 11.4583 45.0088 12.4377C45.0088 13.4214 44.5689 13.9941 43.7969 13.9941Z"
        fill="black"
      />
      <path
        d="M52.8182 10.1799H51.9259L51.1207 13.6289H51.0501L50.1205 10.1799H49.2655L48.3358 13.6289H48.2694L47.4601 10.1799H46.5553L47.8004 14.6997H48.7176L49.6473 11.3711H49.7179L50.6517 14.6997H51.5772L52.8182 10.1799Z"
        fill="black"
      />
      <path
        d="M53.8458 14.6997H54.7382V12.0559C54.7382 11.3503 55.1574 10.9104 55.8173 10.9104C56.4772 10.9104 56.7926 11.2715 56.7926 11.9978V14.6997H57.685V11.7737C57.685 10.6987 57.1288 10.0928 56.1203 10.0928C55.4396 10.0928 54.9914 10.3958 54.7714 10.8979H54.705V10.1799H53.8458V14.6997Z"
        fill="black"
      />
      <path d="M59.0903 14.6997H59.9826V8.41602H59.0903V14.6997Z" fill="black" />
      <path
        d="M63.3386 14.7869C64.6584 14.7869 65.4678 13.9028 65.4678 12.4377C65.4678 10.981 64.6543 10.0928 63.3386 10.0928C62.0188 10.0928 61.2053 10.981 61.2053 12.4377C61.2053 13.9028 62.0146 14.7869 63.3386 14.7869ZM63.3386 13.9941C62.5625 13.9941 62.1267 13.4255 62.1267 12.4377C62.1267 11.4583 62.5625 10.8855 63.3386 10.8855C64.1106 10.8855 64.5505 11.4583 64.5505 12.4377C64.5505 13.4214 64.1106 13.9941 63.3386 13.9941Z"
        fill="black"
      />
      <path
        d="M68.1265 14.0232C67.6409 14.0232 67.2881 13.7866 67.2881 13.3799C67.2881 12.9814 67.5704 12.7698 68.1929 12.7283L69.2969 12.6577V13.0354C69.2969 13.5957 68.7989 14.0232 68.1265 14.0232ZM67.8982 14.7744C68.4917 14.7744 68.9856 14.5171 69.2554 14.0647H69.326V14.6997H70.1851V11.6118C70.1851 10.6572 69.5459 10.0928 68.4129 10.0928C67.3877 10.0928 66.6573 10.5908 66.566 11.3669H67.4292C67.5289 11.0474 67.8733 10.8647 68.3714 10.8647C68.9815 10.8647 69.2969 11.1345 69.2969 11.6118V12.002L68.0726 12.0725C66.9976 12.1389 66.3916 12.6079 66.3916 13.4214C66.3916 14.2473 67.0267 14.7744 67.8982 14.7744Z"
        fill="black"
      />
      <path
        d="M73.2132 14.7744C73.8358 14.7744 74.3629 14.4797 74.6327 13.9858H74.7032V14.6997H75.5582V8.41602H74.6659V10.8979H74.5995C74.3546 10.3999 73.8316 10.1052 73.2132 10.1052C72.0719 10.1052 71.3373 11.01 71.3373 12.4377C71.3373 13.8696 72.0636 14.7744 73.2132 14.7744ZM73.4664 10.9062C74.2135 10.9062 74.6825 11.4998 74.6825 12.4419C74.6825 13.3882 74.2176 13.9734 73.4664 13.9734C72.711 13.9734 72.2586 13.3965 72.2586 12.4377C72.2586 11.4873 72.7152 10.9062 73.4664 10.9062Z"
        fill="black"
      />
      <path
        d="M81.3447 14.7869C82.6645 14.7869 83.4738 13.9028 83.4738 12.4377C83.4738 10.981 82.6604 10.0928 81.3447 10.0928C80.0249 10.0928 79.2114 10.981 79.2114 12.4377C79.2114 13.9028 80.0207 14.7869 81.3447 14.7869ZM81.3447 13.9941C80.5686 13.9941 80.1328 13.4255 80.1328 12.4377C80.1328 11.4583 80.5686 10.8855 81.3447 10.8855C82.1166 10.8855 82.5566 11.4583 82.5566 12.4377C82.5566 13.4214 82.1166 13.9941 81.3447 13.9941Z"
        fill="black"
      />
      <path
        d="M84.655 14.6997H85.5474V12.0559C85.5474 11.3503 85.9666 10.9104 86.6265 10.9104C87.2864 10.9104 87.6018 11.2715 87.6018 11.9978V14.6997H88.4941V11.7737C88.4941 10.6987 87.938 10.0928 86.9294 10.0928C86.2488 10.0928 85.8005 10.3958 85.5806 10.8979H85.5142V10.1799H84.655V14.6997Z"
        fill="black"
      />
      <path
        d="M92.6039 9.05518V10.2007H91.8858V10.9519H92.6039V13.5044C92.6039 14.376 92.9981 14.7246 93.9901 14.7246C94.1644 14.7246 94.3304 14.7039 94.4757 14.679V13.936C94.3512 13.9485 94.2723 13.9568 94.1353 13.9568C93.6913 13.9568 93.4962 13.7493 93.4962 13.2761V10.9519H94.4757V10.2007H93.4962V9.05518H92.6039Z"
        fill="black"
      />
      <path
        d="M95.6735 14.6997H96.5658V12.0601C96.5658 11.3752 96.9726 10.9146 97.703 10.9146C98.3339 10.9146 98.6701 11.2798 98.6701 12.002V14.6997H99.5624V11.782C99.5624 10.707 98.9689 10.0969 98.006 10.0969C97.3253 10.0969 96.848 10.3999 96.6281 10.9062H96.5575V8.41602H95.6735V14.6997Z"
        fill="black"
      />
      <path
        d="M102.781 10.8523C103.441 10.8523 103.873 11.313 103.894 12.0227H101.611C101.661 11.3171 102.122 10.8523 102.781 10.8523ZM103.89 13.4795C103.724 13.8323 103.354 14.0273 102.815 14.0273C102.101 14.0273 101.64 13.5251 101.611 12.7324V12.6826H104.803V12.3713C104.803 10.9519 104.043 10.0928 102.786 10.0928C101.511 10.0928 100.702 11.01 100.702 12.4543C100.702 13.8987 101.495 14.7869 102.79 14.7869C103.823 14.7869 104.545 14.2888 104.749 13.4795H103.89Z"
        fill="black"
      />
      <path
        d="M24.769 20.3011C24.7907 18.6201 25.6934 17.0295 27.1256 16.149C26.2221 14.8587 24.7088 14.0406 23.1344 13.9913C21.4552 13.8151 19.8272 14.9962 18.9715 14.9962C18.0992 14.9962 16.7817 14.0088 15.363 14.038C13.5137 14.0978 11.7898 15.1491 10.8901 16.7659C8.95607 20.1143 10.3987 25.0354 12.2513 27.742C13.1782 29.0673 14.2615 30.5478 15.6789 30.4953C17.066 30.4377 17.584 29.6108 19.2583 29.6108C20.9171 29.6108 21.4031 30.4953 22.8493 30.4619C24.3377 30.4377 25.2754 29.1306 26.1698 27.7927C26.8358 26.8484 27.3483 25.8047 27.6882 24.7002C25.9391 23.9604 24.771 22.2002 24.769 20.3011Z"
        fill="black"
      />
      <path
        d="M22.0373 12.2113C22.8489 11.2371 23.2487 9.98494 23.1518 8.7207C21.912 8.85092 20.7668 9.44348 19.9443 10.3803C19.14 11.2956 18.7214 12.5258 18.8006 13.7417C20.0408 13.7545 21.2601 13.178 22.0373 12.2113Z"
        fill="black"
      />
    </SvgIcon>
  );
};

export const PlayStoreButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "135", height: "40", fill: "none" }}
      width="135"
      height="40"
      viewBox="0 0 135 40"
      fill="none"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="135" height="40" viewBox="0 0 135 40" fill="none">
        <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" fill="white" />
        <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" stroke="black" />
        <path
          d="M68.136 21.7509C65.784 21.7509 63.867 23.5399 63.867 26.0039C63.867 28.4529 65.784 30.2569 68.136 30.2569C70.489 30.2569 72.406 28.4529 72.406 26.0039C72.405 23.5399 70.488 21.7509 68.136 21.7509ZM68.136 28.5829C66.847 28.5829 65.736 27.5199 65.736 26.0049C65.736 24.4739 66.848 23.4269 68.136 23.4269C69.425 23.4269 70.536 24.4739 70.536 26.0049C70.536 27.5189 69.425 28.5829 68.136 28.5829ZM58.822 21.7509C56.47 21.7509 54.553 23.5399 54.553 26.0039C54.553 28.4529 56.47 30.2569 58.822 30.2569C61.175 30.2569 63.092 28.4529 63.092 26.0039C63.092 23.5399 61.175 21.7509 58.822 21.7509ZM58.822 28.5829C57.533 28.5829 56.422 27.5199 56.422 26.0049C56.422 24.4739 57.534 23.4269 58.822 23.4269C60.111 23.4269 61.222 24.4739 61.222 26.0049C61.223 27.5189 60.111 28.5829 58.822 28.5829ZM47.744 23.0569V24.8609H52.062C51.933 25.8759 51.595 26.6169 51.079 27.1319C50.451 27.7599 49.468 28.4529 47.744 28.4529C45.086 28.4529 43.008 26.3099 43.008 23.6519C43.008 20.9939 45.086 18.8509 47.744 18.8509C49.178 18.8509 50.225 19.4149 50.998 20.1399L52.271 18.8669C51.191 17.8359 49.758 17.0469 47.744 17.0469C44.103 17.0469 41.042 20.0109 41.042 23.6519C41.042 27.2929 44.103 30.2569 47.744 30.2569C49.709 30.2569 51.192 29.6119 52.351 28.4039C53.543 27.2119 53.914 25.5359 53.914 24.1829C53.914 23.7649 53.882 23.3779 53.817 23.0559H47.744V23.0569ZM93.052 24.4579C92.698 23.5079 91.618 21.7509 89.411 21.7509C87.22 21.7509 85.399 23.4749 85.399 26.0039C85.399 28.3879 87.204 30.2569 89.62 30.2569C91.569 30.2569 92.697 29.0649 93.165 28.3719L91.715 27.4049C91.232 28.1139 90.571 28.5809 89.62 28.5809C88.67 28.5809 87.993 28.1459 87.558 27.2919L93.245 24.9399L93.052 24.4579ZM87.252 25.8759C87.204 24.2319 88.525 23.3949 89.476 23.3949C90.217 23.3949 90.845 23.7659 91.055 24.2969L87.252 25.8759ZM82.629 29.9999H84.497V17.4989H82.629V29.9999ZM79.567 22.7019H79.503C79.084 22.2019 78.278 21.7509 77.264 21.7509C75.137 21.7509 73.188 23.6199 73.188 26.0209C73.188 28.4049 75.137 30.2579 77.264 30.2579C78.279 30.2579 79.084 29.8069 79.503 29.2919H79.567V29.9039C79.567 31.5309 78.697 32.4009 77.296 32.4009C76.152 32.4009 75.443 31.5799 75.153 30.8869L73.526 31.5639C73.993 32.6909 75.233 34.0769 77.296 34.0769C79.487 34.0769 81.34 32.7879 81.34 29.6459V22.0099H79.568V22.7019H79.567ZM77.425 28.5829C76.136 28.5829 75.057 27.5029 75.057 26.0209C75.057 24.5219 76.136 23.4269 77.425 23.4269C78.697 23.4269 79.696 24.5219 79.696 26.0209C79.696 27.5029 78.697 28.5829 77.425 28.5829ZM101.806 17.4989H97.335V29.9999H99.2V25.2639H101.805C103.873 25.2639 105.907 23.7669 105.907 21.3819C105.907 18.9969 103.874 17.4989 101.806 17.4989ZM101.854 23.5239H99.2V19.2389H101.854C103.249 19.2389 104.041 20.3939 104.041 21.3819C104.041 22.3499 103.249 23.5239 101.854 23.5239ZM113.386 21.7289C112.035 21.7289 110.636 22.3239 110.057 23.6429L111.713 24.3339C112.067 23.6429 112.727 23.4169 113.418 23.4169C114.383 23.4169 115.364 23.9959 115.38 25.0249V25.1539C115.042 24.9609 114.318 24.6719 113.434 24.6719C111.649 24.6719 109.831 25.6529 109.831 27.4859C109.831 29.1589 111.295 30.2359 112.935 30.2359C114.189 30.2359 114.881 29.6729 115.315 29.0129H115.379V29.9779H117.181V25.1849C117.182 22.9669 115.524 21.7289 113.386 21.7289ZM113.16 28.5799C112.55 28.5799 111.697 28.2739 111.697 27.5179C111.697 26.5529 112.759 26.1829 113.676 26.1829C114.495 26.1829 114.882 26.3599 115.38 26.6009C115.235 27.7599 114.238 28.5799 113.16 28.5799ZM123.743 22.0019L121.604 27.4219H121.54L119.32 22.0019H117.31L120.639 29.5769L118.741 33.7909H120.687L125.818 22.0019H123.743ZM106.937 29.9999H108.802V17.4989H106.937V29.9999Z"
          fill="black"
        />
        <path
          d="M47.418 10.2432C47.418 11.0812 47.1701 11.7482 46.673 12.2462C46.109 12.8382 45.3731 13.1342 44.4691 13.1342C43.6031 13.1342 42.8661 12.8342 42.2611 12.2342C41.6551 11.6332 41.3521 10.8892 41.3521 10.0012C41.3521 9.11219 41.6551 8.36819 42.2611 7.76819C42.8661 7.16719 43.6031 6.86719 44.4691 6.86719C44.8991 6.86719 45.3101 6.95119 45.7001 7.11819C46.0911 7.28619 46.404 7.50919 46.6381 7.78819L46.111 8.31619C45.714 7.84119 45.167 7.60419 44.468 7.60419C43.836 7.60419 43.29 7.82619 42.829 8.27019C42.368 8.71419 42.1381 9.29119 42.1381 10.0002C42.1381 10.7092 42.368 11.2862 42.829 11.7302C43.29 12.1742 43.836 12.3962 44.468 12.3962C45.138 12.3962 45.6971 12.1732 46.1441 11.7262C46.4341 11.4352 46.602 11.0302 46.647 10.5112H44.468V9.79019H47.375C47.405 9.94719 47.418 10.0982 47.418 10.2432Z"
          fill="black"
        />
        <path
          d="M52.0281 7.73724H49.2961V9.63924H51.7601V10.3602H49.2961V12.2622H52.0281V13.0002H48.5251V7.00024H52.0281V7.73724Z"
          fill="black"
        />
        <path d="M55.279 13.0002H54.508V7.73724H52.832V7.00024H56.955V7.73724H55.279V13.0002Z" fill="black" />
        <path d="M59.938 13.0002V7.00024H60.709V13.0002H59.938Z" fill="black" />
        <path d="M64.1281 13.0002H63.3572V7.73724H61.6812V7.00024H65.8042V7.73724H64.1281V13.0002Z" fill="black" />
        <path
          d="M73.6089 12.2252C73.0189 12.8312 72.2859 13.1342 71.4089 13.1342C70.5319 13.1342 69.7989 12.8312 69.2099 12.2252C68.6199 11.6192 68.3259 10.8772 68.3259 10.0002C68.3259 9.12323 68.6199 8.38123 69.2099 7.77523C69.7989 7.16923 70.5319 6.86523 71.4089 6.86523C72.2809 6.86523 73.0129 7.17023 73.6049 7.77923C74.1969 8.38823 74.4929 9.12823 74.4929 10.0002C74.4929 10.8772 74.1979 11.6192 73.6089 12.2252ZM69.7789 11.7222C70.2229 12.1722 70.7659 12.3962 71.4089 12.3962C72.0519 12.3962 72.5959 12.1712 73.0389 11.7222C73.4829 11.2722 73.7059 10.6982 73.7059 10.0002C73.7059 9.30223 73.4829 8.72823 73.0389 8.27823C72.5959 7.82823 72.0519 7.60423 71.4089 7.60423C70.7659 7.60423 70.2229 7.82923 69.7789 8.27823C69.3359 8.72823 69.1129 9.30223 69.1129 10.0002C69.1129 10.6982 69.3359 11.2722 69.7789 11.7222Z"
          fill="black"
        />
        <path
          d="M75.5749 13.0002V7.00024H76.513L79.429 11.6672H79.4619L79.429 10.5112V7.00024H80.1999V13.0002H79.3949L76.344 8.10625H76.3109L76.344 9.26224V13.0002H75.5749Z"
          fill="black"
        />
        <path
          d="M47.418 10.2432C47.418 11.0812 47.1701 11.7482 46.673 12.2462C46.109 12.8382 45.3731 13.1342 44.4691 13.1342C43.6031 13.1342 42.8661 12.8342 42.2611 12.2342C41.6551 11.6332 41.3521 10.8892 41.3521 10.0012C41.3521 9.11219 41.6551 8.36819 42.2611 7.76819C42.8661 7.16719 43.6031 6.86719 44.4691 6.86719C44.8991 6.86719 45.3101 6.95119 45.7001 7.11819C46.0911 7.28619 46.404 7.50919 46.6381 7.78819L46.111 8.31619C45.714 7.84119 45.167 7.60419 44.468 7.60419C43.836 7.60419 43.29 7.82619 42.829 8.27019C42.368 8.71419 42.1381 9.29119 42.1381 10.0002C42.1381 10.7092 42.368 11.2862 42.829 11.7302C43.29 12.1742 43.836 12.3962 44.468 12.3962C45.138 12.3962 45.6971 12.1732 46.1441 11.7262C46.4341 11.4352 46.602 11.0302 46.647 10.5112H44.468V9.79019H47.375C47.405 9.94719 47.418 10.0982 47.418 10.2432Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M52.0281 7.73724H49.2961V9.63924H51.7601V10.3602H49.2961V12.2622H52.0281V13.0002H48.5251V7.00024H52.0281V7.73724Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M55.279 13.0002H54.508V7.73724H52.832V7.00024H56.955V7.73724H55.279V13.0002Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M59.938 13.0002V7.00024H60.709V13.0002H59.938Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M64.1281 13.0002H63.3572V7.73724H61.6812V7.00024H65.8042V7.73724H64.1281V13.0002Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M73.6089 12.2252C73.0189 12.8312 72.2859 13.1342 71.4089 13.1342C70.5319 13.1342 69.7989 12.8312 69.2099 12.2252C68.6199 11.6192 68.3259 10.8772 68.3259 10.0002C68.3259 9.12323 68.6199 8.38123 69.2099 7.77523C69.7989 7.16923 70.5319 6.86523 71.4089 6.86523C72.2809 6.86523 73.0129 7.17023 73.6049 7.77923C74.1969 8.38823 74.4929 9.12823 74.4929 10.0002C74.4929 10.8772 74.1979 11.6192 73.6089 12.2252ZM69.7789 11.7222C70.2229 12.1722 70.7659 12.3962 71.4089 12.3962C72.0519 12.3962 72.5959 12.1712 73.0389 11.7222C73.4829 11.2722 73.7059 10.6982 73.7059 10.0002C73.7059 9.30223 73.4829 8.72823 73.0389 8.27823C72.5959 7.82823 72.0519 7.60423 71.4089 7.60423C70.7659 7.60423 70.2229 7.82923 69.7789 8.27823C69.3359 8.72823 69.1129 9.30223 69.1129 10.0002C69.1129 10.6982 69.3359 11.2722 69.7789 11.7222Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          d="M75.5749 13.0002V7.00024H76.513L79.429 11.6672H79.4619L79.429 10.5112V7.00024H80.1999V13.0002H79.3949L76.344 8.10625H76.3109L76.344 9.26224V13.0002H75.5749Z"
          stroke="black"
          strokeWidth="0.2"
          strokeMiterlimit="10"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1565 7.96617C10.0384 8.23367 9.97314 8.56144 9.97314 8.94269V31.0587C9.97314 31.4408 10.0385 31.7686 10.1567 32.036L22.1907 20.0003L10.1565 7.96617ZM10.8517 32.7552C11.2978 32.9461 11.8797 32.8855 12.5141 32.5257L26.6712 24.4809L22.8978 20.7074L10.8517 32.7552ZM27.5737 23.9691L32.0151 21.4457C33.4121 20.6507 33.4121 19.3517 32.0151 18.5577L27.5717 16.0328L23.6048 20.0003L27.5737 23.9691ZM26.6699 15.5204L12.5141 7.4767C11.8796 7.11612 11.2977 7.05596 10.8516 7.2471L22.8977 19.2932L26.6699 15.5204Z"
          fill="black"
        />
      </svg>{" "}
    </SvgIcon>
  );
};
